import React from 'react';
import {Route, Redirect} from 'react-router'


export const PrivateRoute = ({component: Component, isLoggedIn, ...rest}) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: {from: props.location}
          }}
        />
      )
    }
  />
);


export const PrivateRouteForAdmin = ({component: Component, isAdmin, ...rest}) => (
  <Route
    exact
    {...rest}
    render={props =>
      isAdmin ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: {from: props.location}
          }}
        />
      )
    }
  />
);
